
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

interface CampaignEntry {
  id: number;
  name: string;
  includeTemplates: boolean;
}

export default defineComponent({
  name: 'PublishToGalleryDialog',

  components: {
    Dialog,
    InputSwitch,
    SpmButton,
  },

  emits: ['confirm'],

  setup(_, { emit, expose }) {
    const { t } = useI18n();

    const isVisible = ref(false);
    const isLoading = ref(false);
    const campaigns = ref<CampaignEntry[]>([]);

    /**
     * Open the dialog with the list of campaign IDs and names
     */
    const open = (campaignList: { id: number; name: string }[]) => {
      campaigns.value = campaignList.map((c) => ({
        id: c.id,
        name: c.name,
        includeTemplates: true,
      }));
      isVisible.value = true;
    };

    const close = () => {
      isVisible.value = false;
      campaigns.value = [];
      isLoading.value = false;
    };

    const confirm = () => {
      const campaignIds = campaigns.value.map((c) => c.id);
      const campaignIdsWithoutTemplates = campaigns.value
        .filter((c) => !c.includeTemplates)
        .map((c) => c.id);

      isLoading.value = true;
      emit('confirm', { campaignIds, campaignIdsWithoutTemplates });
    };

    /**
     * Called by parent after publish completes (success or error)
     */
    const done = () => {
      close();
    };

    expose({ open, done });

    return {
      t,
      isVisible,
      isLoading,
      campaigns,
      close,
      confirm,
    };
  },
});
